/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UpdateBillingInfoSuccessResponseData,
    UpdateBillingInfoSuccessResponseDataFromJSON,
    UpdateBillingInfoSuccessResponseDataFromJSONTyped,
    UpdateBillingInfoSuccessResponseDataToJSON,
} from './UpdateBillingInfoSuccessResponseData';

/**
 * 
 * @export
 * @interface UpdateBillingInfoSuccessResponse
 */
export interface UpdateBillingInfoSuccessResponse {
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof UpdateBillingInfoSuccessResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof UpdateBillingInfoSuccessResponse
     */
    message: string;
    /**
     * 
     * @type {UpdateBillingInfoSuccessResponseData}
     * @memberof UpdateBillingInfoSuccessResponse
     */
    data: UpdateBillingInfoSuccessResponseData;
}

export function UpdateBillingInfoSuccessResponseFromJSON(json: any): UpdateBillingInfoSuccessResponse {
    return UpdateBillingInfoSuccessResponseFromJSONTyped(json, false);
}

export function UpdateBillingInfoSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBillingInfoSuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': UpdateBillingInfoSuccessResponseDataFromJSON(json['data']),
    };
}

export function UpdateBillingInfoSuccessResponseToJSON(value?: UpdateBillingInfoSuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': UpdateBillingInfoSuccessResponseDataToJSON(value.data),
    };
}

